import { render, staticRenderFns } from "./LogSetting.vue?vue&type=template&id=1974e964&scoped=true"
import script from "./LogSetting.vue?vue&type=script&lang=js"
export * from "./LogSetting.vue?vue&type=script&lang=js"
import style0 from "./LogSetting.vue?vue&type=style&index=0&id=1974e964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974e964",
  null
  
)

export default component.exports